import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required } from '@vuelidate/validators';
import CreditCardForm from '@/components/creditcards/Form';
import AddressForm from '@/components/forms/Address';
export default {
  name: 'BillingForm',
  components: {
    CreditCardForm,
    AddressForm
  },
  props: {
    states: {
      type: Array,
      default() {
        return [];
      }
    },
    countries: {
      type: Array,
      default() {
        return [];
      }
    },
    name: {
      type: String,
      default: ''
    },
    address: {
      type: Object,
      default() {
        return null;
      }
    },
    billingrecord: {
      type: Object,
      default() {
        return null;
      }
    },
    isRegistration: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loading: false,
      default: {
        billing: {
          billingtype_id: 1,
          creditcardtype: null,
          name: null,
          nickname: null,
          firstname: null,
          lastname: null,
          number: null,
          expmonth: null,
          expyear: null,
          cvc: null,
          valid: false,
          cardedit: 1
        },
        billingAddress: {
          address1: null,
          address2: null,
          city: null,
          state_id: null,
          zip: null,
          country_id: '184',
          valid: true
        }
      },
      form: {
        billing: {},
        billingAddress: {},
        billingAddressSame: true
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.billingrecord) {
        this.form.billing = Object.assign({}, this.billingrecord);
        this.form.billing.name = this.form.billing.firstname + ' ' + this.form.billing.lastname;
        this.form.billingAddress = Object.assign({}, this.billingrecord.address);
        this.form.billingAddressSame = false;
      } else {
        this.form.billing = Object.assign({}, this.default.billing);
        this.form.billingAddress = Object.assign({}, this.address ? this.address : this.default.billingAddress);
      }
      this.$v.form.billing.$touch();
    },
    setAddress(data) {
      this.form.billingAddress = data || Object.assign({}, this.default.billingAddress);
    },
    setCard(data) {
      const temp = Object.assign({}, this.form.billing);
      if (data && data.valid) {
        temp.creditcardtype = data.creditcardtype;
        temp.number = data.number;
        temp.expmonth = data.expmonth;
        temp.expyear = data.expyear;
        temp.cvc = data.cvc;
      } else {
        temp.creditcardtype = null;
        temp.number = null;
        temp.expmonth = null;
        temp.expyear = null;
        temp.cvc = null;
      }
      temp.valid = data.valid;
      temp.cardedit = data.cardedit;
      this.form.billing = Object.assign({}, temp);
    },
    getFormState(field) {
      if (this.isRegistration) {
        return !this.$v.form.billing[field].$error;
      } else {
        return !this.$v.form.billing[field].$error ? null : false;
      }
    }
  },
  computed: {
    isNew() {
      return !this.billingrecord || !this.billingrecord.id;
    },
    isValid() {
      return !this.$v.form.$invalid && this.form.billing.valid && (this.form.billingAddressSame || this.form.billingAddress.valid);
    }
  },
  watch: {
    name() {
      this.form.billing.name = this.name;
    },
    form: {
      deep: true,
      handler(n) {
        this.$emit('update', n);
      }
    }
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    form: {
      billing: {
        name: {
          required
        }
      }
    }
  }
};